export default [
    {
        path: '/finance/finance-transfer',
        name: 'finance-transfer',
        props: true,
        component: () => import('@/views/finance/transfer/index.vue'),
        meta: {
            pageTitle: 'Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/finance-transfer/add',
        name: 'create-finance-transfer',
        component: () => import('@/views/finance/transfer/create.vue'),
        meta: {
            pageTitle: 'Create Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                to: { name: 'finance-transfer' },
                },
                {
                text: 'Create Transfer',
                active: true,
                },
            ],
        },
    },
    {
        path: '/finance/finance-transfer/:id',
        name: 'detail-finance-transfer',
        props: true,
        component: () => import('@/views/finance/transfer/detail.vue'),
        meta: {
            pageTitle: 'Detail Transfer',
            breadcrumb: [
                {
                text: 'Transfer',
                to: { name: 'finance-transfer' },
                },
                {
                text: 'Detail Transfer',
                active: true,
                },
            ],
        },
    },
]